import { Component, effect, ElementRef, input, signal, viewChild, OnInit } from '@angular/core';
import { TextWidthPipe } from '../../pipes/text-width.pipe';
import { RidKlankCard } from '../rid-klank-card/rid-klank-card';

@Component({
  selector: 'rid-word-path-klank',
  imports: [RidKlankCard, TextWidthPipe],
  templateUrl: './rid-word-path-klank.html',
  styleUrl: './rid-word-path-klank.css',
})
export class RidWordPathKlank implements OnInit {
  klank = input.required<string>();
  klankId = input<string>(); // used to track changes
  isPendingRemoval = input<boolean>(false);
  pendingNeighbor = input<'BEFORE' | 'AFTER' | undefined>(undefined);

  // the currently shown klank with a unique id to track animations
  protected shown = signal<{ k: string; id: string } | undefined>(undefined);

  rootEl = viewChild.required<ElementRef<HTMLElement>>('rootEl');

  constructor() {
    effect(() => {
      const klank = this.klank();
      this.klankId(); // track changes

      this.swap(klank);
    });
  }

  ngOnInit(): void {
    this.shown.set({ k: this.klank(), id: `${Math.random()}` });
  }

  private async swap(klank: string) {
    this.shown.set({ k: klank, id: `${Math.random()}` });
  }

  public getSnapPosition() {
    const el = this.rootEl().nativeElement;
    const rect = el.getBoundingClientRect();

    return { x: rect.left + rect.width / 2, y: rect.top + 0.75 * rect.height };
  }
}
